import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { ModalLayout } from '@/features/modal/modals/ModalLayout';
import { Button } from '@/components/buttons/Button';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';
import { GTagEvents, triggerGTag } from '@/lib/gTagManager';
import { openZendesk } from '@/components/Zendesk';
import { BaseModalProps } from '@/features/modal/types';

export const AccountBlockedModal = ({ closeModal }: BaseModalProps): JSX.Element => {
  const intl = useIntl();
  const absoluteNavigate = useAbsoluteNavigate();

  const openHelp = () => {
    triggerGTag(GTagEvents.account_blocked_help_click);
    openZendesk();
    closeModal();
  };

  const returnToHome = () => {
    triggerGTag(GTagEvents.account_blocked_home_click);
    closeModal();
    absoluteNavigate('/');
  };

  return (
    <ModalLayout data-testid="account-blocked-modal" close={closeModal} className="!bg-gray-800">
      <div className="p-8 text-white">
        <FormattedMessage
          id="accountBlockedModal.message"
          values={{
            b: str => <span className="font-bold">{str}</span>,
            p: str => <p className="mt-4">{str}</p>,
          }}
        />
        <div className="mt-8">
          <Button
            text={intl.formatMessage({ id: 'help.contactButton' })}
            type="button"
            btnType="primary"
            onClickHandler={openHelp}
          />
          <div className="mt-4">
            <Button
              text={intl.formatMessage({ id: 'accountBlockedModal.cta' })}
              type="button"
              btnType="secondary"
              onClickHandler={returnToHome}
            />
          </div>
        </div>
      </div>
    </ModalLayout>
  );
};
